import CustomerGroups from "../common/Sidebar/CustomerGroups";

interface CustomerAndGroupsProps {
  toggleSidebar: (isOpen: boolean | null, selectedMenu: string | null) => void;
}

const CustomerAndGroups: React.FC<CustomerAndGroupsProps> = ({
  toggleSidebar,
}) => {
  return (
    <div className="fixed left-70 bottom-0 top-0 flex flex-col h-full bg-darkcolor-700 w-[416px] p-3 2xl:p-4 py-9 pb-16 z-50">
      <div className="w-full h-full">
        <div className="flex flex-wrap justify-between items-center mb-[16px]">
          <h6 className="text-[19px] font-[500] text-neutral-25">
            Customer & groups
          </h6>
        </div>
        <CustomerGroups toggleSidebar={toggleSidebar} />
      </div>
    </div>
  );
};

export default CustomerAndGroups;
